export default __webpack_public_path__ + "static/media/music.076e51db.webp";